import { useManageRecoilNexus } from "../services/recoil/nexus";

export const RecoilNexus: React.VFC = () => {
  useManageRecoilNexus();

  return null;
};
